var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Paginate',{attrs:{"value":_vm.value,"pageCount":_vm.totalPageCount,"page-range":_vm.range,"isFirstPage":_vm.isFirstPage,"isLastPage":_vm.isLastPage},on:{"moveByNumber":_vm.moveByNumber}})
}
var staticRenderFns = []

export { render, staticRenderFns }